import { LoginPage } from "./pages/login-page.js";
import { RegisterPage } from "./pages/register-page.js";
import { ProfilePage } from "./pages/profile-page.js";
import { UsersAdminPage } from "./pages/users-admin-page.js";
export class UserClientRegistrar {
    constructor(deps) {
        const { pageRouteRegistry } = deps;
        pageRouteRegistry.registerPage({
            path: "/login", component: LoginPage, key: "user-login",
            meta: { title: "Login", requiresAuth: false }, modName: "user-client",
        });
        pageRouteRegistry.registerPage({
            path: "/register", component: RegisterPage, key: "user-register",
            meta: { title: "Register", requiresAuth: false }, modName: "user-client",
        });
        pageRouteRegistry.registerPage({
            path: "/profile", component: ProfilePage, key: "user-profile",
            meta: { title: "Profile", requiresAuth: true }, modName: "user-client",
        });
        pageRouteRegistry.registerPage({
            path: "/admin/users", component: UsersAdminPage, key: "user-admin",
            meta: { title: "User Management", requiresAuth: true, requiresAdmin: true }, modName: "user-client",
        });
    }
}
//# sourceMappingURL=user-client-registrar.js.map